/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Alert } from '@mui/material';
import { ProgressChartView } from './ChartView';
import { ApiService } from '../../services/apiService';
import { ApiResponse } from '../../types/api';

const apiService = new ApiService();

export const ProgressChartLoader: React.FC<{hidden?: boolean}> = ({hidden}) => {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState<ApiResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const token = searchParams.get('token') || '';
  const moduleId = searchParams.get('moduleId') || '';
  const userId = parseInt(searchParams.get('userId') || '');
  const activityId = parseInt(searchParams.get('activityId') || '');
  const onlyRelevantData = searchParams.get('onlyRelevantData') !== 'false';
  const isRestrictionProject = searchParams.get('isRestrictionProject') === 'true';

  useEffect(() => {
    if (hidden || data) {
      return;
    }
    loadData();
  }, [token, moduleId, userId, activityId, hidden]);

  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);

      if (!token || !moduleId) {
        throw new Error('Faltan parámetros requeridos: token y moduleId');
      }

      apiService.setAuth(token, moduleId);
      
      const response = await apiService.getMeteredData(
        userId, 
        activityId, 
        onlyRelevantData, 
        isRestrictionProject
      );
      
      setData(response);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error cargando datos');
    } finally {
      setLoading(false);
    }
  };

  if (hidden) {
    return <></>
  }

  if (loading) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        Cargando datos...
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">
          Error: {error}
        </Alert>
      </Box>
    );
  }

  if (!data) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="warning">No se encontraron datos</Alert>
      </Box>
    );
  }

  return <ProgressChartView data={data} />;
};